export function setTotalPrice(stepFeatures, stepValue, stateTotalPrice) {
  let addonsSubTotalPrice = 0;
  // Addons - several options
  const addonsValues = stepValue.split(",");

  if (addonsValues && addonsValues.length > 0) {
    addonsValues.map((addonValue, _) => {
      const addonPrice = parseInt(stepFeatures[parseInt(addonValue)].price);
      if (addonPrice) {
        addonsSubTotalPrice += addonPrice;
      }
      return addonsSubTotalPrice;
    });
  }
  
  stateTotalPrice = addonsSubTotalPrice;

  return stateTotalPrice;
}

export default setTotalPrice;
